import React from 'react';
import { Link } from 'react-router-dom';
import { Mail, MapPin, Linkedin, Twitter, Facebook } from 'lucide-react';

const COMPANY_LOGO = "https://customer-assets.emergentagent.com/job_8a1d6c9e-dd92-45ef-96ba-a4a899e05fe9/artifacts/p4tsc02v_image.png";

const Footer = () => {
  const currentYear = new Date().getFullYear();

  const quickLinks = [
    { path: '/', label: 'Home' },
    { path: '/about', label: 'About Us' },
    { path: '/services', label: 'Services' },
    { path: '/portfolio', label: 'Portfolio' },
    { path: '/careers', label: 'Careers' },
    { path: '/contact', label: 'Contact' },
  ];

  const services = [
    { path: '/timeshare-opc', label: 'Timeshare OPC Marketing' },
    { path: '/services', label: 'Lead Generation' },
    { path: '/services', label: 'Digital Advertising' },
    { path: '/services', label: 'CRM & Automation' },
    { path: '/services', label: 'AI Tools' },
  ];

  return (
    <footer className="bg-[#0F172A] text-white" data-testid="footer">
      {/* Main Footer */}
      <div className="container-max mx-auto px-4 sm:px-6 lg:px-8 py-16">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12">
          {/* Company Info */}
          <div className="space-y-6">
            <img 
              src={COMPANY_LOGO} 
              alt="Prestigious Marketing" 
              className="h-12 w-auto object-contain brightness-0 invert"
            />
            <p className="text-slate-400 text-sm leading-relaxed">
              Your vision, Our strategies, We win together. Prestigious Marketing Inc delivers 
              data-driven marketing solutions that drive real results.
            </p>
            <div className="flex gap-4">
              <a 
                href="#" 
                className="w-10 h-10 rounded-full bg-slate-800 flex items-center justify-center hover:bg-[#1E3A8A] transition-colors"
                aria-label="LinkedIn"
              >
                <Linkedin size={18} />
              </a>
              <a 
                href="#" 
                className="w-10 h-10 rounded-full bg-slate-800 flex items-center justify-center hover:bg-[#1E3A8A] transition-colors"
                aria-label="Twitter"
              >
                <Twitter size={18} />
              </a>
              <a 
                href="#" 
                className="w-10 h-10 rounded-full bg-slate-800 flex items-center justify-center hover:bg-[#1E3A8A] transition-colors"
                aria-label="Facebook"
              >
                <Facebook size={18} />
              </a>
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="text-lg font-semibold mb-6">Quick Links</h4>
            <ul className="space-y-3">
              {quickLinks.map((link) => (
                <li key={link.path + link.label}>
                  <Link 
                    to={link.path}
                    className="text-slate-400 hover:text-white transition-colors text-sm"
                  >
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Services */}
          <div>
            <h4 className="text-lg font-semibold mb-6">Services</h4>
            <ul className="space-y-3">
              {services.map((service, idx) => (
                <li key={idx}>
                  <Link 
                    to={service.path}
                    className="text-slate-400 hover:text-white transition-colors text-sm"
                  >
                    {service.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Contact Info */}
          <div>
            <h4 className="text-lg font-semibold mb-6">Contact Us</h4>
            <ul className="space-y-4">
              <li className="flex items-start gap-3">
                <Mail size={18} className="text-[#EA580C] mt-0.5 flex-shrink-0" />
                <a href="mailto:info@prestigious-marketing.com" className="text-slate-400 hover:text-white transition-colors text-sm">
                  info@prestigious-marketing.com
                </a>
              </li>
              <li className="flex items-start gap-3">
                <MapPin size={18} className="text-[#EA580C] mt-0.5 flex-shrink-0" />
                <span className="text-slate-400 text-sm">
                  Orlando, Florida
                </span>
              </li>
            </ul>
          </div>
        </div>
      </div>

      {/* Bottom Bar */}
      <div className="border-t border-slate-800">
        <div className="container-max mx-auto px-4 sm:px-6 lg:px-8 py-6">
          <div className="flex flex-col md:flex-row justify-between items-center gap-4">
            <div className="text-center md:text-left">
              <p className="text-slate-400 text-sm">
                &copy; 2026 Prestigious Marketing
              </p>
              <p className="text-slate-500 text-xs mt-1">
                A Prestigious Companies Network | Strategic Partner of the Prestigious Travel Club Foundation
              </p>
            </div>
            <div className="flex gap-6">
              <Link to="/terms" className="text-slate-500 hover:text-slate-300 text-sm">
                Terms of Use
              </Link>
              <Link to="/privacy" className="text-slate-500 hover:text-slate-300 text-sm">
                Privacy Policy
              </Link>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
